
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderSearch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderSearch"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalProductPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalDiscount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalTax"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalPayment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exportVat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":160}};
    doc.loc.source = {"body":"fragment OrderSearch on OrderSearch {\n  id\n  orderStatus\n  totalProductPrice\n  totalDiscount\n  totalTax\n  shippingPrice\n  totalPayment\n  exportVat\n  createdAt\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
